<mat-card class="example-card">
  <mat-card-header
    class="titreFrm items-center justify-center"
    style="padding: 2em 0em !important"
  >
    <mat-card-title>Rapport visite client</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <ng-template #attente>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>
    <div class="grid w-full grid-cols-3">
      <div class="col-span-3 m-8 mt-16 h-56">
        <mat-form-field appearance="outline" class="w-9/12">
          <mat-label>Date Visite : </mat-label>
          <input
            matInput
            [matDatepicker]="dateDebut"
            placeholder="Date Visite"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="dateDebut"
          ></mat-datepicker-toggle>
          <mat-datepicker #dateDebut></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-span-3 m-8 h-56">
        <mat-form-field appearance="outline" class="w-9/12">
          <input matInput placeholder="Nom client" />
        </mat-form-field>
      </div>
      <div class="col-span-3 m-8 h-56">
        <mat-form-field appearance="outline" class="w-9/12">
          <input matInput placeholder="Adresse" />
        </mat-form-field>
      </div>
      <div class="m-8 mr-0 h-56">
        <mat-form-field appearance="outline" class="w-full">
          <input matInput placeholder="Contact" />
        </mat-form-field>
      </div>
      <div class="m-8 mr-0 h-56">
        <mat-form-field appearance="outline" class="w-full">
          <input matInput placeholder="Email" />
        </mat-form-field>
      </div>
      <div class="m-8 mr-0 h-56">
        <mat-form-field appearance="outline" class="w-full">
          <input matInput placeholder="Tél" />
        </mat-form-field>
      </div>
      <div class="col-span-3 m-8 h-56">
        <mat-form-field appearance="outline" class="w-9/12">
          <input matInput placeholder="Position" />
        </mat-form-field>
      </div>
      <div class="col-span-3 m-8 h-56">
        <mat-form-field appearance="outline" class="w-9/12">
          <input matInput placeholder="Activité" />
        </mat-form-field>
      </div>
      <div class="col-span-3 m-8 h-56">
        <mat-form-field appearance="outline" class="w-9/12">
          <input matInput placeholder="Potentiel client" />
        </mat-form-field>
      </div>
      <div class="col-span-3 m-8 h-56">
        <mat-form-field appearance="outline" class="w-9/12">
          <input matInput placeholder="Gamme vendue" />
        </mat-form-field>
      </div>
      <div class="col-span-3 m-8 h-56">
        <mat-form-field appearance="outline" class="w-9/12">
          <input matInput placeholder="Concurrents présents" />
        </mat-form-field>
      </div>
      <div class="col-span-3 m-8 h-56">
        <mat-form-field appearance="outline" class="w-9/12">
          <input matInput placeholder="Potentiel par catégorie située" />
        </mat-form-field>
      </div>
      <div class="col-span-3 m-8 h-56">
        <mat-form-field appearance="outline" class="w-9/12">
          <input matInput placeholder="Gamme proposée" />
        </mat-form-field>
      </div>
      <div class="col-span-3 m-8 h-56">
        <mat-form-field appearance="outline" class="w-9/12">
          <input matInput placeholder="Feedback visite" />
        </mat-form-field>
      </div>
      <div class="col-span-3 m-8 h-56">
        <mat-form-field appearance="outline" class="w-9/12">
          <input matInput placeholder="Prochaine étape" />
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>
</mat-card>
